export enum LoanTermType {
    Fixed = 'Fixed',
    Flexible = 'Flexible'
}

export const LoanTermTypeLabels: Record<LoanTermType, string> = {
    [LoanTermType.Fixed]: 'Plenti Advantage',
    [LoanTermType.Flexible]: 'Plenti Flex'
};

const LOAN_TERM_TYPE_SET = new Set<LoanTermType>(Object.values(LoanTermType));

const isLoanTermType = (termType: string): termType is LoanTermType => {
    return LOAN_TERM_TYPE_SET.has(termType as LoanTermType);
};

export const getLoanTermTypeLabel = (termType: string | null | undefined) => {
    if (!termType) {
        return '';
    }

    return isLoanTermType(termType) ? LoanTermTypeLabels[termType] : termType;
};
